import { useDispatch } from "react-redux";
import CustomToast from "../../toastify/CustomToast";
import { useEffect, useState } from "react";
import { GET_PRIVACY_POLICY } from "../../redux/actions/CommonActions";
import Parser from "html-react-parser";
import '../termPolicy/TermsCss.css'
import logo from "../../assets/images/logo.svg";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState('')
  const getData = async () => {
    dispatch(GET_PRIVACY_POLICY())
      .then((res) => {
        console.log(res);
        setData(res[0])

      })
      .catch((e) => {
        CustomToast.error(e);
        console.log(e);
      })
  }
  useEffect(() => {
    getData();
  }, [])

    return (
      <div style={{ marginTop: 20 }} className="text-center">
         <div className="logo-container">
        <img src={logo} alt="Logo" className="logo-img" />
      </div>
           <p style={{ fontSize: 20, fontWeight: 700, color: "black" }}>
             {data?.title}
           </p>
           <div className="html-wrapper">
             {typeof data?.description === 'string' ? Parser(data.description) : <p>Loading...</p>}
           </div>
     
         </div>
    );
  };
  
  export default PrivacyPolicy;